<template>
  <div class="containerFullHeight authBg">
    <b-container fluid>
      <b-row>
        <b-col lg="8" md="7" />
        <b-col lg="4" md="5" :class="mobile?'authSectionMobile':'authSection'">
          <nuxt />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'LayoutAuth',
  middleware: ['loginRedirect'],
  data () {
    return {
      desktop: false,
      tab: false,
      mobile: false
    }
  },
  mounted () {
    this.getScreen()
  },
  methods: {
    getScreen () {
      const ua = navigator.userAgent
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        this.tab = true
      } else if (
        /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        this.mobile = true
      } else {
        this.desktop = true
      }
    }
  }
}
</script>
<style lang="scss">
.authSection {
  padding: 5vw 5vw 2vw 5vw !important;
  background: rgba(255, 255, 255, 0.8);
  min-height: 100vh;
}
.authSectionMobile {
  padding: 5vw 5vw 2vw 5vw !important;
  background: rgba(255, 255, 255, 0.8);
  height: 100%;
}
</style>
